import * as StepConstants from 'notebook/protocols/StepConstants';

const StepEmphasis = {
  renderEmphasis(type: string | null | undefined, html: string) {
    if (!type) {
      return html;
    }
    switch (type) {
      case StepConstants.TYPE_CRITICAL:
        return `<span class="step-type step-type-critical">CRITICAL</span>${html}`;
      case StepConstants.TYPE_PAUSE:
        return `<span class="step-type step-type-pause">PAUSE</span>${html}`;
      default:
        throw new Error(`Unexpected render type: ${type}`);
    }
  },
};

export default StepEmphasis;
